/**
 * @name mobile.constants
 * @description Core mobile.constants in ngx-responsive
 *
 * @license MIT
 */
import { IMobile } from '../interfaces';

export const MOBILE: IMobile = {
    IPHONE: 'Iphone',
    ANDROID: 'Android',
    WINDOWS_PHONE: 'Windows Phone',
    BLACKBERRY: 'Blackberry',
    GENERIC_MOBILE: 'Generic Mobile'
};
